import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  Renderer2,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MessageService } from 'primeng/api';
import { WalletSocketService } from 'src/app/components/wallet/wallet.component.service';
import { ApiCore } from 'src/app/config/api';
import { AuthService } from 'src/app/core/auth/auth.service';
import { SessionService } from 'src/app/core/auth/session.service';
//import { SessionService } from 'src/app/core/auth/session.service';
import { ApiService } from 'src/app/core/http/api.service';
//import { SocketServiceUpdate } from 'src/app/core/socket/socket-update.service';
import { I18nService } from 'src/app/shared/services/i18n.service';
import { ProfileMenuService } from 'src/app/shared/services/profile-menu.service';
import { BannerService } from 'src/app/components/banner/banner.service';
import { AppComponent } from 'src/app/app.component';
import { DeviceDetectorService } from 'src/app/shared/services/device-detector.service';
import { MobileAgentServiceService } from 'src/app/shared/services/mobile-agent-service.service';
import { EventMenuProfileService } from 'src/app/components/profile-menu/profile-menu.service';
import { InactivityService } from 'src/app/shared/services/inactivity.service';
import { Subscription } from 'rxjs';
import { SocketInactivityService } from 'src/app/core/socket/socket-inactivity.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
})
export class MainLayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  menuCollapsed: boolean = false;

  public wallet: {
    bonus: number;
    credits: number;
    total: number;
  } = {
    bonus: 0,
    credits: 0,
    total: 0,
  };
  public showBonos = false;
  public showCajero = false;
  public newNotiBonos = false;
  public newNotiCajeros = false;
  showLoadSpin: boolean = false;
  isMobile: boolean = false;
  isWeb: boolean = false;
  isLoggedIn: boolean = false;
  showMissedInformation: boolean = false;
  IsBuyCreditsVisible: boolean = false;
  showMissedInfoGame: boolean = false;
  showCreateAccountModal: boolean = false;

  logo: string | null = 'assets/images/no-photo-available.png';
  profilePicture: string | null = 'assets/images/imageProfile.png';
  labelProfile: string = 'Mi Perfil';
  userStatus: any;
  idPlayer: any;
  updateWalletInfo: any;
  social_networks: any = {};

  totalBalance: number = 0;

  showLoadSkeleton: any = {
    wallet: false,
    profile: false,
  };
  showCredits = false;
  showNotifications = false;
  showBonuses = false;
  showProfile = false;
  items: MenuItem[] = [];
  isPCPlayer: boolean = false;
  disabledButtons: boolean = true;
  public isSidebarExpanded = true;
  public showLoginModal: boolean = false;
  sidebarStatic = true;
  overlayMenuActive: boolean = false;
  staticMenuDesktopInactive = false;
  staticMenuMobileActive: boolean = false;
  private socketInactivitySubscription!: Subscription;
  private inactivitySubscription!: Subscription;

  constructor(
    private readonly eventMenuProfileService: EventMenuProfileService,
    private i18nService: I18nService,
    private readonly auth: AuthService,
    private readonly api: ApiService,
    private readonly message: MessageService,
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly profileMenu: ProfileMenuService,
    private readonly userSession: SessionService,
    public app: AppComponent,
    private readonly walletSocketService: WalletSocketService,
    private readonly bannerService: BannerService,
    private readonly session: SessionService,
    private readonly mobile: MobileAgentServiceService, //private readonly socketUpdate: SocketServiceUpdate,
    private readonly deviceDetector: DeviceDetectorService, //private readonly socketUpdate: SocketServiceUpdate,
    private readonly inactivityService: InactivityService,
    private readonly socketInactivityService: SocketInactivityService,
    private renderer: Renderer2,
    private toast: ToastService
  ) {
    this.listenCloseSession();
    this.eventMenuProfileService.$eventLogin.subscribe((e) => {
      this.isLoggedIn = true;
    });
    this.verifyLoggedIn();
    this.i18nService.localeEvent.subscribe({
      next: () => {
        this.useTranslate();
      },
    });
    this.profileMenu.getData().subscribe((items: MenuItem[]) => {
      items.forEach((element) => {
        switch (element.label) {
          case 'Mi Perfil':
            element.command = () => this.openProfile();
            break;
          case 'Cerrar Sesión':
            element.command = () => this.logout();
            break;
          case 'Lobby':
            element.command = () => this.openHome();
            break;
          default:
            break;
        }
      });
      this.items = items;
    });
    this.listenHideNotiCashier();
    this.listenHideNotiBonus();
    /*
    this.socketUpdate.databaseUpdate().subscribe((data) => {
      try {
        this.updateWalletInfo = data;
      
        const userId = this.updateWalletInfo?.userId;
        const pcPlayerId = this.updateWalletInfo?.pcPlayerId;
      
        if (this.idPlayer === userId || this.idPlayer === pcPlayerId) {
          this.totalBalance = this.updateWalletInfo.balance;
        }
      
      } catch (error) {
        console.error('Error al obtener el valor actualizado:', error);
      }
      

    });
    */
  }

  @HostListener('window:focus', ['$event'])
  onFocus(event: FocusEvent) {
    if (this.isLoggedIn) {
      this.checkGameSession();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.verifyLoggedIn();
    }, 3000);
  }

  ngOnInit() {
    this.auth.isLoggedIn$.subscribe((status) => {
      this.isLoggedIn = status;
    });
    this.verifyLoggedIn();
    this.getCoorporateConfiguration();
    this.getNewNotis();
    this.getNewNotisCajero();
    this.walletSocketService.connectSocket();

    this.isWeb = !this.mobile.isMobileDevice();

    if (this.isLoggedIn && !this.auth.checkRememberMe()) {
      this.socketInactivityService.startSocket();
      this.inactivitySubscription =
        this.inactivityService.inactivity$.subscribe((isInactive) => {
          if (isInactive) {
            this.logout();
          }
        });
    } else {
      this.socketInactivitySubscription?.unsubscribe();
      this.socketInactivityService.stopSocket();
    }
  }
  ngOnDestroy(): void {
    this.walletSocketService?.disconnectSocket();
    //this.socketUpdate.disconnectSocket(); // Desconectar la conexión al salir del componente
  }

  closeBuyCreditsDialog = (event: boolean) =>
    (this.IsBuyCreditsVisible = event);

  closeDialog = () => {
    this.showMissedInformation = false;
    this.showMissedInfoGame = false;
  };

  buyCredits = () => {
    if (this.userStatus == 'Incompleto') this.showMissedInformation = true;
    else this.IsBuyCreditsVisible = true;
  };

  verifyLoggedIn = () => {
    try {
      this.isLoggedIn = this.auth.isAuthenticated();
    } catch (error) {
      this.isLoggedIn = false;
      console.warn(error);
    }

    if (this.isLoggedIn) {
      this.verifyValidToken();
    }
  };

  getBalance(userId?: string, pcplayer?: boolean) {
    if (pcplayer) {
      this.api
        .list(ApiCore.PC_PLAYER + '/wallet-balance', { id: userId })
        .subscribe({
          next: (res) => {
            this.totalBalance = res.data.balance + res.data.bonus;
            this.wallet = {
              bonus: res.data.bonus,
              credits: res.data.balance,
              total: res.data.balance + res.data.bonus,
            };
          },
          error: (err) => {
            this.message.add({
              key: 'tc',
              severity: 'error',
              summary: 'Error al cargar el balance del usuario',
            });
            console.error(err);
          },
        });
    } else {
      this.api.list(ApiCore.USER + '/wallet-balance').subscribe({
        next: (res) => {
          this.totalBalance = res.data.balance + res.data.bonus;
          this.wallet = {
            bonus: res.data.bonus,
            credits: res.data.balance,
            total: res.data.balance + res.data.bonus,
          };
        },
        error: (err) => {
          this.message.add({
            key: 'tc',
            severity: 'error',
            summary: 'Error al cargar el balance del usuario',
          });
          console.error(err);
        },
      });
    }
  }

  getCoorporateConfiguration = () => {
    this.showLoadSkeleton.wallet = true;
    this.showLoadSpin = true;
    this.api.getCoorporateCasinoConfig().subscribe({
      next: (res) => {
        console.log(res);
        this.logo = res.data.logoCasinoUrl;
        this.showLoadSkeleton.wallet = false;
        this.showLoadSpin = false;
        this.social_networks = {
          countryCode: res.data.countryCodeId,
          whatsapp: res.data.contactPhone,
          facebook: res.data.facebook,
          instagram: res.data.instagram,
          tiktok: res.data.tiktok,
        };

        this.setFavicon(res.data.faviconCasinoUrl);
      },
      error: (err) => console.error(err),
    });
  };

  openProfile = () => this.router.navigate(['/app/home/profile']);

  openHome = () => this.router.navigate(['/']);

  useTranslate = () => this.translate.use(this.i18nService.getLanguage());

  verifyValidToken = () => {
    this.showLoadSkeleton.profile = true;
    this.api.list(ApiCore.USER + '/me').subscribe({
      next: (res) => {
        //console.log('data me-->', res.data);
        this.isPCPlayer = res.data.isPCPlayer;
        this.disabledButtons = res.data.isPCPlayer;
        this.eventMenuProfileService.toggleIsPCPlayer(res.data.isPCPlayer);
        this.profilePicture =
          res.data.profilePictureUrl ?? '../assets/images/imageProfile.png';
        this.userStatus = res.data.userStatus;
        this.idPlayer = res.data.id;
        this.showLoadSkeleton.profile = false;
        this.getBalance(res.data.id, res.data.isPCPlayer);
      },
      error: () => {
        console.error('Su sesión expiró o no ha iniciado sesión');
        this.auth.destroySession();
        this.openHome();
        // this.toast.showError('Su sesión expiró o no ha iniciado sesión')
      },
    });
  };

  logout = () => {
    //lo borramos de la tabla de delete session
    this.userSession.deleteUserGameSession().subscribe((res) => {
      console.log('destroying session...', res);
      this.auth.logout().subscribe({
        next: () => {
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['/app/home']));

          this.isLoggedIn = false;

          if (this.socketInactivitySubscription) {
            this.socketInactivitySubscription?.unsubscribe();
            this.socketInactivityService.stopSocket();
          }
          window.location.reload();
        },
        error: (err) => console.error(err),
      });
    });
  };
  redirectHome() {
    // Si está en open-game tenemos que borrar la sessión del juego
    this.eventMenuProfileService.toggleMenu();
    this.bannerService.changeNameOfBanner(
      this.session.getItem('casinoName') as string
    );
    const urlWithoutQuery = this.router.url.split('?')[0];
    console.log(urlWithoutQuery);
    if (urlWithoutQuery === '/app/home/open-game') {
      this.deleteCurrentGameSession();
    }
    //siempre redirigir al home
    this.router.navigate(['/app/home']);
  }

  private deleteCurrentGameSession() {
    this.userSession.deleteUserGameSession().subscribe((res) => {
      console.log('destroying session...');
      console.log(res);
    });
  }

  public changeLoginModalVisibility($event: boolean): void {
    this.showLoginModal = $event;
  }

  // public onModalLoginHide($event: boolean): void {
  //   console.log('cerrando modal login');
  //   // this.showLoginModal = $event;
  // }
  toggleBonos() {
    if (this.showBonos === false) {
      this.newNotiBonos = false;
      this.seenNotiBonos();
    }
    this.showBonos = !this.showBonos;
  }
  hideBonos() {
    this.showBonos = false;
  }
  seenNotiBonos() {
    this.api
      .updateDirect(ApiCore.OPERATOR + '/update-bonuses-pendings', {})
      .subscribe({
        next: (res) => {
          console.log({ updateDirect: res });
          // idPlayer
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  getNewNotis() {
    this.api.list(ApiCore.OPERATOR + '/pending-bonuses').subscribe({
      next: (res) => {
        console.log({ res });
        if (res?.data?.length > 0) {
          this.newNotiBonos = true;
        }
        // idPlayer
      },
      error: (err) => {
        this.message.add({
          key: 'tc',
          severity: 'error',
          summary: 'Error al cargar el balance del usuario',
        });
        console.error(err);
      },
    });
  }

  public changeShowCreateAccountModal(val: boolean): void {
    this.showCreateAccountModal = val;
  }

  toggleMenu(event: boolean) {
    this.menuCollapsed = event;
  }
  hideCajero() {
    this.showCajero = false;
  }
  toggleCajero() {
    if (this.showCajero === false) {
      this.newNotiCajeros = false;
      this.seenNotiCajero();
    }
    this.showCajero = !this.showCajero;
  }
  seenNotiCajero() {
    this.api
      .updateDirect(ApiCore.OPERATOR + '/update-transactions-pendings', {})
      .subscribe({
        next: (res) => {
          console.log({ updateCashier: res });
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  getNewNotisCajero() {
    this.api.list(ApiCore.OPERATOR + '/pending-transactions').subscribe({
      next: (res) => {
        console.log({ transactionsPendings: res });
        if (res?.data?.length > 0) {
          this.newNotiCajeros = true;
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  public noAccount(): void {
    this.showLoginModal = false;
    this.showCreateAccountModal = true;
  }

  listenHideNotiCashier() {
    this.eventMenuProfileService.$eventHideNotiCashier.subscribe((e) => {
      this.seenNotiCajero();
      this.newNotiCajeros = false;
    });
  }
  listenHideNotiBonus() {
    this.eventMenuProfileService.$eventHideNotiBonus.subscribe((e) => {
      this.seenNotiBonos();
      this.newNotiBonos = false;
    });
  }

  listenCloseSession() {
    this.eventMenuProfileService.$eventCloseSesionFromOutsideMenu.subscribe(
      (e) => {
        this.isLoggedIn = false;
        this.auth.removeToken();
        //location.reload();
        //this.router.navigate(['/app/home']);
        this.toast.showError('Sesión finalizada');
      }
    );
  }

  setFavicon(url: string): void {
    if (!url) return;
    const link: HTMLLinkElement | null =
      document.querySelector('link[rel="icon"]');
    if (link) {
      this.renderer.setAttribute(link, 'href', url);
    } else {
      const link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.setAttribute(link, 'href', url);
      this.renderer.appendChild(document.head, link);
    }
  }

  handleLoginSuccess(): void {
    this.isLoggedIn = true; // update isLoggedIn
    this.showLoginModal = false; // close LoggedIn window
    this.verifyLoggedIn();
    this.eventMenuProfileService.login();
  }
  checkGameSession() {
    this.api.getGameSession(ApiCore.SESSION_GAMES).subscribe({
      next: (res) => {
        if (res.statusCode === 403) {
          this.auth.destroySession();
        }
      },
      error: (error) => {
        if (error.status === 403 || error.error.statusCode === 403) {
          this.auth.destroySession();
          this.openHome();
        }
        // if (error.status === 403) {
        //   this.auth.destroySession();
        // }
      },
    });
  }
}
